import React from "react";
import { Star } from "lucide-react";
import { ratingConfig } from "../config/rating";

const RatingBadge: React.FC = () => {
  const { ratingValue, ratingCount, bestRating } = ratingConfig;

  const fullStars = Math.floor(ratingValue);
  const hasHalfStar =
    ratingValue - fullStars >= 0.25 && ratingValue - fullStars < 0.75;
  const adjustedFull =
    ratingValue - fullStars >= 0.75 ? fullStars + 1 : fullStars;
  const emptyStars = bestRating - adjustedFull - (hasHalfStar ? 1 : 0);

  return (
    <div className="flex flex-col items-center gap-1">
      <div className="flex items-center gap-0.5">
        {Array.from({ length: adjustedFull }).map((_, i) => (
          <Star
            key={`full-${i}`}
            className="w-5 h-5 text-yellow-400 fill-yellow-400"
          />
        ))}
        {hasHalfStar && (
          <div className="relative w-5 h-5">
            <Star className="absolute inset-0 w-5 h-5 text-yellow-400" />
            <Star
              className="absolute inset-0 w-5 h-5 text-yellow-400 fill-yellow-400"
              style={{ clipPath: "inset(0 50% 0 0)" }}
            />
          </div>
        )}
        {Array.from({ length: Math.max(0, emptyStars) }).map((_, i) => (
          <Star
            key={`empty-${i}`}
            className="w-5 h-5 text-yellow-400"
          />
        ))}
      </div>
      <p className="text-sm text-gray-500">
        <span className="font-semibold text-gray-700">
          {ratingValue}/{bestRating}
        </span>{" "}
        basierend auf{" "}
        <span className="font-semibold text-gray-700">{ratingCount}</span>{" "}
        Bewertungen
      </p>
    </div>
  );
};

export default RatingBadge;
